export default "__VITE_ASSET__df1b88dd__"